﻿(function ($) {

	$.widget('lb.dialog', {
		options: {
			urlFormat: "{0}?template=ajaxdialog"
		},
		_create: function () {
		    if (!($.browser.msie && parseInt($.browser.version, 10) <= 8) && ($(window).width() >= 768) || this.element.data("type") == "mortage"){
				this.element.bind("click", $.proxy(this._pressed, this));
		    }
            
		},
		_pressed: function (e) {
			e.preventDefault();
			var url = this.element.attr("href");
			if (!url.length) {
				return;
			}
			this.open(url);
		},
		open: function (url) {
			opts = this.options;
			this.url = url;
		    //TODO: Write this plugin to support other dialogs than contact us.
			if (this.element.data("type") == "mortage")
			{
			    var wrapper = $("#mortage");
			    url = "";
			    if (this.url.indexOf("?") > 0) {
			        url = this.options.urlFormat.replace("?", "&");
			    } else {
			        url = this.options.urlFormat;
			    }
			    url = url.replace("{0}", this.url);
			    if (this.element.data("loaded") != "loaded")
			    {
			        wrapper.load(url, function () {

			            $("#mortage .ui-tabs a").live("click", function (e) {

			                if ($(this).attr("class") == "close") {
			                    wrapper.fadeOut(200, function () {
			                        $("div.mortage-dim").hide();
			                    });
			                }
			                e.preventDefault();
			            });
			            

			            $("#mortage-dim").fadeIn(200, function () {
			                wrapper.fadeIn(200);
			            });

			        });
			        this.element.data("loaded", "loaded");
			    }
			    else
			    {
			        $("#mortage-dim").fadeIn(200, function () {
			            wrapper.fadeIn(600);
			        });
			    }
			    
			}
			else if (this.element.data("type") == "bilalana") {
			    var wrapper = $("#bila");
			    url = "";
			    if (this.url.indexOf("?") > 0) {
			        url = this.options.urlFormat.replace("?", "&");
			    } else {
			        url = this.options.urlFormat;
			    }
			    url = url.replace("{0}", this.url);
			    if (this.element.data("loaded") != "loaded") {
			        wrapper.load(url, function () {

			            $("#bila .ui-tabs a").live("click", function (e) {

			                if ($(this).attr("class") == "close") {
			                    wrapper.fadeOut(200, function () {
			                        $("div.bila-dim").hide();
			                    });
			                }
			                e.preventDefault();
			            });


			            $("#bila-dim").fadeIn(200, function () {
			                wrapper.fadeIn(200);
			            });

			        });
			        this.element.data("loaded", "loaded");
			    }
			    else {
			        $("#bila-dim").fadeIn(200, function () {
			            wrapper.fadeIn(600);
			        });
			    }
			}
			else
			{
			    var wrapper = $("#contact-us-wrapper");

			    url = "";
			    if (this.url.indexOf("?") > 0) {
			        url = this.options.urlFormat.replace("?", "&");
			    } else {
			        url = this.options.urlFormat;
			    }
			    url = url.replace("{0}", this.url);

			    wrapper.load(url, function () {

			        $("#contact-us-wrapper .ui-tabs a").live("click", function (e) {

			            if ($(this).attr("class") != "close") {
			                $("html").css("overflow", "hidden");
			                var link = $(this);
			                link.closest("li").addClass("active").siblings().removeClass("active");
			                var wrap = $('.contact-us-html').addClass("jquery-lightbox-loading");
			                wrap.css("height", wrapper.outerHeight() + "px");
			                $('.contact-us-html form').remove();

			                wrap.load(opts.urlFormat.replace("{0}", link.attr("href")), function () {
			                    $(".contact-us-html").removeClass("jquery-lightbox-loading");
			                    wrap.css("height", "auto");

			                });

			            } else {
			                wrapper.fadeOut(600, function () {
			                    $("div.conctact-dim").css("display", "none");
			                });
			                wrapper.html("");
			            }
			            e.preventDefault();
			        });
			        $("#contact-man").after("<div id='conctact-dim' class='conctact-dim'></div>");

			        $("#conctact-dim").fadeIn(200, function () {
			            wrapper.css("height", "auto");
			            //wrapper.css("width", "900px");
			            wrapper.fadeIn(600);
			        });

			    });
			}
			

		}
	});

})(jQuery);